import { Injectable } from '@angular/core';

interface ReportingApiRequestContext {
  loggedInAgentDbId: string | null;
  viewedAgentDbId: string | null;
}

@Injectable({ providedIn: 'root' })
export class ReportingApiRequestContextService {
  private context: ReportingApiRequestContext = {
    loggedInAgentDbId: null,
    viewedAgentDbId: null,
  };

  setLoggedInAgentDbId(agentDbId: string | null): void {
    this.context = {
      ...this.context,
      loggedInAgentDbId: agentDbId?.trim() || null,
    };
  }

  setViewedAgentDbId(agentDbId: string | null): void {
    this.context = {
      ...this.context,
      viewedAgentDbId: agentDbId?.trim() || null,
    };
  }

  getContext(): ReportingApiRequestContext {
    return this.context;
  }
}
